import { render } from "./EvaluationQuestionBatchPane.vue?vue&type=template&id=28d535cb&ts=true"
import script from "./EvaluationQuestionBatchPane.vue?vue&type=script&lang=ts"
export * from "./EvaluationQuestionBatchPane.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__